import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";

export const PortfolioAssets = ({ portfolioAsset, isDarkMode }) => {
  const [series, setSeries] = useState([]);
  const [labels, setLabels] = useState([]);
  const [total, setTotal] = useState(0);
  console.log('portfolioAsset', portfolioAsset);
  useEffect(() => {
    // Filter holdings >= 1
    const rawHoldings = portfolioAsset?.map((item) => parseFloat(item.Holding) || 0);
    const rawLabels = portfolioAsset?.map((item) => item["Asset Type"] || "Unknown");

    const filteredData = rawHoldings?.map((value, index) => ({ value, label: rawLabels[index] }));

    const filteredHoldings = filteredData?.map((item) => item.value);
    const filteredLabels = filteredData?.map((item) => item.label);
    const total = filteredHoldings?.reduce((sum, curr) => sum + curr, 0);

    setSeries(filteredHoldings);
    setLabels(filteredLabels);
    setTotal(total);
  }, [portfolioAsset]);

  // const options = {
  //   chart: {
  //     type: "donut",
  //   },
  //   labels: labels,
  //   colors: [
  //     "#123200",
  //     "#03641B",
  //     "#047D22",
  //     "#059529",
  //     "#2DC653",
  //     "#32F964",
  //     "#59FA81",
  //     "#80FC9F",
  //     "#CCFF33",
  //     "#F8AA24",
  //     "#F8AA20",
  //     "#B4E375",
  //     "#60BD3B",
  //     "#23674B",
  //     "#4DBD8F",
  //   ],
  //   plotOptions: {
  //     pie: {
  //       donut: {
  //         size: "90%",
  //         labels: {
  //           show: true,
  //           name: {
  //             show: true,
  //             offsetY: -5,
  //             fontSize: "16px",
  //             formatter: () => "Assets",
  //           },
  //           value: {
  //             show: false,
  //           },
  //           total: {
  //             show: true,
  //             label: "Total",
  //             fontSize: "16px",
  //             color: isDarkMode ? "#fff" : "#373D3F",
  //             formatter: () => `${total.toFixed(2)}%`,
  //           },
  //         },
  //       },
  //     },
  //   },
  //   dataLabels: {
  //     enabled: false,
  //   },
  //   legend: {
  //     show: false,
  //   },
  //   tooltip: {
  //     theme: "dark",
  //     y: {
  //       formatter: (value) => `${value.toFixed(2)}%`,
  //     },
  //   },
  // };
  const options = {
    chart: { type: "donut" },
    labels,
    colors: [
      "#cfcf0e", "#26b99a", "#3498db", "#2bd927", "#267e24", "#60BD3B", "#59FA81", "#80FC9F", "#4DBD8F",
    ],
    plotOptions: {
      pie: {
        donut: {
          size: "80%",
          labels: {
            show: true,
            total: {
              show: false,
              label: 'Total',
              formatter: () => `${total.toFixed(2)}%`,
              color: "#000",
              fontSize: "20px",
            },
            name: {
              show: true,
              offsetY: -5,
              fontSize: "16px",
              formatter: () => "Assets",
            },
            value: {
              show: true,
              fontSize: "20px",
              formatter: (val) => `${val}%`, // 🔹 show hovered slice’s % only
            },
          },
        },
      },
    },
    dataLabels: { enabled: false },
    legend: { show: false },
    tooltip: {
      theme: "dark",
      custom: ({ series, seriesIndex, w }) => `<div style="background-color: #0009; padding: 10px; border-radius: 5px;">
        <span>${w.globals.labels[seriesIndex]}: ${series[seriesIndex]}%</span>
      </div>`,
    },
    responsive: [
      {
        breakpoint: 992, // for tablets
        options: {
          chart: {
            width: 300,
          },
        },
      },
      {
        breakpoint: 768, // for mobile
        options: {
          chart: {
            // width: 250,
          },
        },
      },
    ],
  };
  return (
    <div className="row custom-donut-row">
      {/* Donut Chart */}
      <div className="col-md-12 col-lg-7  d-flex align-items-center justify-content-center">
        <Chart options={options} series={series} type="donut" width="100%" />
      </div>

      {/* Scrollable Legend */}
      {/* <div className="col-lg-4 pt-3 ">
        <div className="scroll-container " style={{ maxHeight: "250px", overflowY: "auto" }}>
          {portfolioAsset?.map((item, index) => {
            const holding = parseFloat(item.Holding) || 0;
            if (holding < 1) return null;

            return (
              <div key={index} className="legend-item mb-2">
                  <div className="d-flex align-items-center">
                  <span
                    
                    className="legend-color"
                    style={{
                      backgroundColor:
                        options.colors[index % options.colors.length],
                    }}
                  ></span>
                  <span className="legend-text refer">{item["Asset Type"]}Equity Equity </span>
                </div>
                <span className="legend-percentage refer">{holding.toFixed(0)}%</span>
              </div>
            );
          })}
        </div>
      </div> */}

      <div className="col-lg-5 pt-3 ">
        <div className="scroll-container" style={{ maxHeight: "250px" }}>
          {portfolioAsset?.map((item, index) => {
            const holding = parseFloat(item.Holding) || 0;
            if (holding <= 0) return null;

            return (
              <div key={index} className="legend-item">
                <div className="d-flex align-items-center">
                  <span
                    className="legend-color"
                    style={{
                      backgroundColor: options.colors[index % options.colors.length],
                    }}
                  ></span>
                  <span className="legend-text refer" style={{ width: "100px" }}>
                    {item["Asset Type"]}
                  </span>
                </div>
                <span className="legend-percentage refer" style={{ width: "100px" }}>
                  {holding.toFixed(2)}%
                </span>
              </div>
            );
          })}

        </div>
      </div>
    </div>
  );
};

export default PortfolioAssets;
